import { Constants, effectsVolume } from "../Utils/Constants";
import { Finali, RedSplit, BlackSplit, HotNumbers, RedSnake, PrisonBets, MagicRing, ColdNumbers, Button1, Button2, Button4, Button3, NeighbourBet } from "../Utils/ButtonActions";
import { Language, Messages } from "./Language";
import { MiscButton } from "./MiscButton";
import { Assets } from "./Utils/Assets";
import { Client } from "@core/Client";

//track and board misc buttons + presets button
export class MiscButtonsContainer extends Phaser.GameObjects.Container {
	// Is the neighbour bet button drawn after presets?
	private static neighbour_bet_button_after = false
	private static hide_top_preset_buttons = true
	/**
	 * Relatively positions the target GameObject based on the parent GameObject positions with alignment settings
	 * @example Centered: setRelativePosition(this.preseToggleButton, this.presetToggleButtonText, 0.5, 0.5)
	 * @example Horizontally right, vertically centered: setRelativePosition(this.preseToggleButton, this.presetToggleButtonText, 1, 0.5)
	 * @param parent Parent GameObject
	 * @param element Target GameObject for positioning
	 * @param halign 0.0 to 1.0 value for horizontal alignment
	 * @param valign 0.0 to 1.0 value for vertical alignment
	 */
	static SetRelativePosition(parent: Phaser.GameObjects.Image | Phaser.GameObjects.Sprite | Phaser.GameObjects.Text, element: Phaser.GameObjects.Image | Phaser.GameObjects.Sprite | Phaser.GameObjects.Text, halign: number, valign: number): void {
		let x = parent.x + halign * (parent.displayWidth - element.displayWidth)
		let y = parent.y + valign * (parent.displayHeight - element.displayHeight)
		element.setPosition(x, y)
	}

	constructor(scene: Phaser.Scene, private eventEmitter: Phaser.Events.EventEmitter) {
		super(scene);

		this.createPresetButtons();
		this.scene.game.events.addListener("TOGGLE_PRESETS_VISIBILITY", () => this.TogglePresetsVisibility())
	}

	createPresetButtons(): void {
		/**
		 * NOTE: https://github.com/photonstorm/phaser/issues/3722
		 */
		var g = this.scene.make.graphics({}).fillStyle(0x000000).fillRoundedRect(0, 0, 800, 800, { tl: 25, tr: 25, bl: 0, br: 0 })
		g.generateTexture(Constants.PRESETS_PANEL.BACKGROUND_NAME, 800, 800)
		g.destroy()

		var b = this.scene.make.graphics({}).fillStyle(0x08350C).fillRoundedRect(0, 0, 800, 800, { tl: 25, tr: 25, bl: 0, br: 0 })
		b.generateTexture("GreenBGPresets", 800, 800)
		b.destroy()

		let eventHandler = (p: Phaser.Input.Pointer, x: number, y: number, e: Phaser.Types.Input.EventData) => {
			e.stopPropagation();
			// this.setVisible(false);
			this.ResetToggleButton();
			this.scene.sound.play(Constants.SOUNDS.SLIDER_CHANGE, { volume: 0.20 * effectsVolume })
			this.scene.tweens.add({
				targets: this,
				duration: 300,
				x: this.scene.scale.width,
				y: this.scene.scale.height,
				scale: 0,
				alpha: 0,
				onComplete: () => {
					this.setVisible(false)
				}
			})
		}
		let eventDownHandler = (p: Phaser.Input.Pointer, x: number, y: number, e: Phaser.Types.Input.EventData) => {
			e.stopPropagation();
		}

		this.interactiveBackground = new Phaser.GameObjects.Rectangle(this.scene, 0, 0)
		this.interactiveBackground.setOrigin(0)
		// this.interactiveBackground.isFilled = false
		this.interactiveBackground.setFillStyle(0x0E0E0E, 0.1)
		this.interactiveBackground.setInteractive()
		this.interactiveBackground.on("pointerup", eventHandler)
		this.interactiveBackground.on("pointerdown", eventDownHandler)
		this.interactiveBackground.setAlpha(1)
		this.scene.children.add(this.interactiveBackground)

		// Texture generated above and is not part of the loaded spritesheets
		this.presetsBackground = new Phaser.GameObjects.Sprite(this.scene, 0, 0, Constants.PRESETS_PANEL.BACKGROUND_NAME)
		this.presetsBackground.setOrigin(0)
		this.presetsBackground.setInteractive()
		this.presetsBackground.on("pointerup", eventHandler)
		this.presetsBackground.on("pointerdown", eventDownHandler)
		// this.presetsBackground.setVisible(false);
		this.add(this.presetsBackground)

		// Texture generated above and is not part of the loaded spritesheets
		this.presetsGreenBackground = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "GreenBGPresets")
		this.presetsGreenBackground.setOrigin(0)
		this.presetsGreenBackground.setInteractive()
		this.presetsGreenBackground.on("pointerup", eventHandler)
		this.presetsGreenBackground.on("pointerdown", eventDownHandler)
		// this.presetsGreenBackground.setVisible(false);
		this.add(this.presetsGreenBackground)

		/* 
		this.presetToggleButton = new ToggleButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Switch.Normal, Assets.PresetPanel.Buttons.Preset_Switch.Disabled, Assets.PresetPanel.Buttons.Preset_Switch.Hover, new TogglePresetPanel(this))
		this.add(this.presetToggleButton)

		this.presetToggleButtonText = new GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.PRESETS), Constants.PRESETS_PANEL.BUTTON_FONT);
		this.add(this.presetToggleButtonText)
		*/
		// Samo language ID od teksta ki je na gumbu rabiš dat zraven v konstruktor, in ne rabiš kreirat Text objektov posebaj, se nardijo znotraj classa
		// Layout od tekstov se posodobi z .AlignText()
		// Glede na to da so tu vsi znotraj containerja, v bistvu AlignText rabiš samo če se spremeni size tega containerja

		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_1.Normal, Assets.PresetPanel.Buttons.Preset_Button_1.Disabled, Assets.PresetPanel.Buttons.Preset_Button_1.Hover, new Finali(this), false, 22))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_2.Normal, Assets.PresetPanel.Buttons.Preset_Button_2.Disabled, Assets.PresetPanel.Buttons.Preset_Button_2.Hover, new RedSplit(this), false, 23))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_3.Normal, Assets.PresetPanel.Buttons.Preset_Button_3.Disabled, Assets.PresetPanel.Buttons.Preset_Button_3.Hover, new BlackSplit(this), false, 24))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_4.Normal, Assets.PresetPanel.Buttons.Preset_Button_4.Disabled, Assets.PresetPanel.Buttons.Preset_Button_4.Hover, new HotNumbers(this), false, 25))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_5.Normal, Assets.PresetPanel.Buttons.Preset_Button_5.Disabled, Assets.PresetPanel.Buttons.Preset_Button_5.Hover, new RedSnake(this), false, 26))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_6.Normal, Assets.PresetPanel.Buttons.Preset_Button_6.Disabled, Assets.PresetPanel.Buttons.Preset_Button_6.Hover, new PrisonBets(this), false, 27))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_7.Normal, Assets.PresetPanel.Buttons.Preset_Button_7.Disabled, Assets.PresetPanel.Buttons.Preset_Button_7.Hover, new MagicRing(this), false, 28))
		this.presetButtons.push(new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Button_8.Normal, Assets.PresetPanel.Buttons.Preset_Button_8.Disabled, Assets.PresetPanel.Buttons.Preset_Button_8.Hover, new ColdNumbers(this), false, 29))
		this.presetButtons.push(new MiscButton(this.scene, 0, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Zero_Game.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new Button1(0), false, 18));
		this.presetButtons.push(new MiscButton(this.scene, 1, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Big_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new Button2(1), false, 19));
		this.presetButtons.push(new MiscButton(this.scene, 2, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Orphans.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new Button3(2), false, 20));
		this.presetButtons.push(new MiscButton(this.scene, 4, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Small_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new Button4(4), false, 21));

		this.OnBoardTypeToggle(true);

		this.add(this.presetButtons)
		this.presetButtons.forEach(button => {
			// button.setVisible(false)
			// button.TextElement.setVisible(false)
			this.add(button.TextElement)
		});

		this.presetButtonIcons.push(new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Zero_Game_Icon.png"))
		this.presetButtonIcons.push(new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Big_Series_Icon.png"))
		this.presetButtonIcons.push(new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Orphans_Icon.png"))
		this.presetButtonIcons.push(new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Serie_58_Icon.png"))

		this.presetButtonIcons.forEach(icon => {
			icon.setOrigin(0)
			// icon.setVisible(false)
			this.add(icon)
		})

		this.neigbourBetButton = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Board.Buttons.Neighbour_Bet.Normal, Assets.Board.Buttons.Neighbour_Bet.Disabled, Assets.Board.Buttons.Neighbour_Bet.Hover, new NeighbourBet(), false, 14)
		// this.neigbourBetButton.setVisible(false)
		this.add(this.neigbourBetButton)

		this.neighbourBetText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.NEIGBOR_BET), Constants.BOARD.MISC_BUTTON_FONT)
		// this.neighbourBetText.setVisible(false)
		this.add(this.neighbourBetText)

		this.setVisible(false)
	}

	setVisible(value: boolean): this {
		// Overriden because interactiveBackground has to be part of the scene container
		super.setVisible(value)
		this.interactiveBackground.setVisible(value)
		return
	}

	getWidth(): number {
		return (0 - (this.presetButtons[8].x + this.presetButtons[8].displayWidth * 5));
	}

	OnResize(viewportWidth: number, viewportHeight: number, portraitMode?: boolean, boardY?: number, boardHeight?: number): void {
		let buttonW = viewportWidth * (1 - 2 * Constants.BOARD.RELATIVE_SIDE_MARGIN) / (14 + 12 * Constants.BOARD.RELATIVE_SPACING_H + Constants.BOARD.RELATIVE_SPACING_ZERO)
		let sourceButtonDimensions = { width: this.presetButtons[0].OrigWidth, height: this.presetButtons[0].OrigHeight }
		let sourceButtonRatio = sourceButtonDimensions.width / sourceButtonDimensions.height
		let buttonH = buttonW / sourceButtonRatio

		let scaleW: number = ((buttonW) / (this.presetButtons[0].OrigWidth * 0.86));
		let scaleH: number = ((buttonH) / (this.presetButtons[0].OrigHeight * 0.86));

		//nov button width!!!!
		this.presetButtons.forEach((button, i) => {
			button.setScale(scaleW, scaleH)
		});

		this.presetButtonIcons.forEach(icon => {
			icon.setScale(scaleW, scaleH)
		})

		let marginLeft = viewportWidth * 0.01
		let marginTop = viewportHeight * 0.01
		let offsetFromTopButtons = 0.2
		let offsetNeighbourButton = 0.1
		let marginBottom = viewportHeight * 0.01

		if (MiscButtonsContainer.neighbour_bet_button_after) {
			this.presetButtons[8].setPosition(marginLeft, marginTop)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[8], this.presetButtonIcons[0], 0.5, 0.9)

			this.presetButtons[0].setPosition(this.presetButtons[8].x, this.presetButtons[8].y + this.presetButtons[8].displayHeight + this.presetButtons[8].displayWidth * offsetFromTopButtons)
			this.presetButtons[1].setPosition(this.presetButtons[0].x + this.presetButtons[0].displayWidth, this.presetButtons[0].y)
			this.presetButtons[2].setPosition(this.presetButtons[1].x + this.presetButtons[1].displayWidth, this.presetButtons[0].y)
			this.presetButtons[3].setPosition(this.presetButtons[2].x + this.presetButtons[2].displayWidth, this.presetButtons[0].y)

			this.presetButtons[0].AlignText()
			this.presetButtons[1].AlignText()
			this.presetButtons[2].AlignText()
			this.presetButtons[3].AlignText()

			this.presetButtons[9].setPosition(this.presetButtons[0].x + this.presetButtons[0].displayWidth, this.presetButtons[8].y)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[9], this.presetButtonIcons[1], 0.5, 0.9)
			this.presetButtons[10].setPosition(this.presetButtons[1].x + this.presetButtons[1].displayWidth, this.presetButtons[8].y)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[10], this.presetButtonIcons[2], 0.5, 0.9)
			this.presetButtons[11].setPosition(this.presetButtons[2].x + this.presetButtons[2].displayWidth, this.presetButtons[8].y)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[11], this.presetButtonIcons[3], 0.5, 0.9)

			this.presetButtons[8].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
			this.presetButtons[9].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
			this.presetButtons[10].AlignText(0.5, Client.logic.IsBoard ? 0.45 : 0.5)
			this.presetButtons[11].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)

			this.presetButtons[4].setPosition(this.presetButtons[0].x, this.presetButtons[3].y + this.presetButtons[3].displayHeight)
			this.presetButtons[5].setPosition(this.presetButtons[4].x + this.presetButtons[4].displayWidth, this.presetButtons[4].y)
			this.presetButtons[6].setPosition(this.presetButtons[5].x + this.presetButtons[5].displayWidth, this.presetButtons[4].y)
			this.presetButtons[7].setPosition(this.presetButtons[6].x + this.presetButtons[6].displayWidth, this.presetButtons[4].y)

			this.presetButtons[4].AlignText()
			this.presetButtons[5].AlignText()
			this.presetButtons[6].AlignText()
			this.presetButtons[7].AlignText()

			this.neigbourBetButton.setScale(scaleW, scaleH)
			this.neigbourBetButton.setPosition((this.presetButtons[5].x + this.presetButtons[6].x) / 2, this.presetButtons[4].y + this.presetButtons[4].displayHeight + this.presetButtons[4].displayHeight * offsetNeighbourButton)

			this.neighbourBetText.setScale(this.neigbourBetButton.scaleX, this.neigbourBetButton.scaleY)
			MiscButtonsContainer.SetRelativePosition(this.neigbourBetButton, this.neighbourBetText, 0.5, 0.7)

			this.interactiveBackground.setDisplaySize(viewportWidth, viewportHeight)

			this.presetsBackground.setPosition(0, 0);
			this.presetsBackground.displayWidth = this.presetButtons[8].x + this.presetButtons[7].x + this.presetButtons[7].displayWidth
			// this.presetsBackground.displayHeight = this.presetButtons[7].y + this.presetButtons[7].displayHeight
			this.presetsBackground.displayHeight = this.neigbourBetButton.y + this.neigbourBetButton.displayHeight + marginBottom

			let firstWidth = this.presetButtons[8].x + this.presetButtons[7].x + this.presetButtons[7].displayWidth
			let greenWidth = firstWidth * 0.997
			let mainHeight = this.neigbourBetButton.y + this.neigbourBetButton.displayHeight + marginBottom
			let nextHeight = mainHeight * 0.997
			this.presetsGreenBackground.setPosition((firstWidth - greenWidth) / 2, (mainHeight - nextHeight) / 2);
			this.presetsGreenBackground.displayWidth = greenWidth
			// this.presetsGreenBackground.displayHeight = this.presetButtons[7].y + this.presetButtons[7].displayHeight
			this.presetsGreenBackground.displayHeight = nextHeight
		} else {
			this.presetButtons[8].setPosition(marginLeft, marginTop)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[8], this.presetButtonIcons[0], 0.5, 0.9)

			let neigbourBetX = (this.presetButtons[0].x + this.presetButtons[3].x) / 2
			let neigbourBetY = this.presetButtons[4].y + this.presetButtons[4].displayHeight + this.presetButtons[4].displayHeight * offsetNeighbourButton
			neigbourBetY = this.presetButtons[8].y + this.presetButtons[8].displayHeight + this.presetButtons[8].displayWidth * offsetFromTopButtons
			this.neigbourBetButton.setScale(scaleW, scaleH)
			this.neigbourBetButton.setPosition(neigbourBetX, neigbourBetY)

			this.presetButtons[0].setPosition(this.presetButtons[8].x, this.neigbourBetButton.y + this.neigbourBetButton.displayHeight + this.presetButtons[8].displayWidth * offsetFromTopButtons)
			this.presetButtons[1].setPosition(this.presetButtons[0].x + this.presetButtons[0].displayWidth, this.presetButtons[0].y)
			this.presetButtons[2].setPosition(this.presetButtons[1].x + this.presetButtons[1].displayWidth, this.presetButtons[0].y)
			this.presetButtons[3].setPosition(this.presetButtons[2].x + this.presetButtons[2].displayWidth, this.presetButtons[0].y)

			this.presetButtons[0].AlignText()
			this.presetButtons[1].AlignText()
			this.presetButtons[2].AlignText()
			this.presetButtons[3].AlignText()

			this.presetButtons[4].setPosition(marginLeft, this.presetButtons[0].y + this.presetButtons[0].displayHeight)
			this.presetButtons[5].setPosition(this.presetButtons[4].x + this.presetButtons[4].displayWidth, this.presetButtons[4].y)
			this.presetButtons[6].setPosition(this.presetButtons[5].x + this.presetButtons[5].displayWidth, this.presetButtons[4].y)
			this.presetButtons[7].setPosition(this.presetButtons[6].x + this.presetButtons[6].displayWidth, this.presetButtons[4].y)

			this.presetButtons[4].AlignText()
			this.presetButtons[5].AlignText()
			this.presetButtons[6].AlignText()
			this.presetButtons[7].AlignText()

			this.presetButtons[9].setPosition(this.presetButtons[0].x + this.presetButtons[0].displayWidth, this.presetButtons[8].y)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[9], this.presetButtonIcons[1], 0.5, 0.9)
			this.presetButtons[10].setPosition(this.presetButtons[1].x + this.presetButtons[1].displayWidth, this.presetButtons[8].y)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[10], this.presetButtonIcons[2], 0.5, 0.9)
			this.presetButtons[11].setPosition(this.presetButtons[2].x + this.presetButtons[2].displayWidth, this.presetButtons[8].y)
			MiscButtonsContainer.SetRelativePosition(this.presetButtons[11], this.presetButtonIcons[3], 0.5, 0.9)

			this.presetButtons[8].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
			this.presetButtons[9].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
			this.presetButtons[10].AlignText(0.5, Client.logic.IsBoard ? 0.45 : 0.5)
			this.presetButtons[11].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)

			this.neigbourBetButton.setPosition((this.presetButtons[0].x + this.presetButtons[3].x) / 2, neigbourBetY)
			// this.neighbourBetText.setScale(this.neigbourBetButton.scaleX, this.neigbourBetButton.scaleY)
			if (this.neighbourBetText.displayWidth > this.neigbourBetButton.displayWidth * 0.90)
				this.neighbourBetText.setScale((this.neigbourBetButton.displayWidth * 0.90) / this.neighbourBetText.width)
			else {
				this.neighbourBetText.setScale(this.neigbourBetButton.scaleX, this.neigbourBetButton.scaleY)
			}
			// MiscButtonsContainer.SetRelativePosition(this.neigbourBetButton, this.neighbourBetText, 0.67, 0.82)

			if (MiscButtonsContainer.hide_top_preset_buttons) {
				this.presetButtons[8].setVisible(false)
				this.presetButtons[9].setVisible(false)
				this.presetButtons[10].setVisible(false)
				this.presetButtons[11].setVisible(false)

				this.presetButtons[8].TextElement.setVisible(false)
				this.presetButtons[9].TextElement.setVisible(false)
				this.presetButtons[10].TextElement.setVisible(false)
				this.presetButtons[11].TextElement.setVisible(false)

				this.presetButtonIcons.forEach((icon) => icon.setVisible(false))

				this.neigbourBetButton.setPosition(this.neigbourBetButton.x, this.presetButtons[8].y)
				// MiscButtonsContainer.SetRelativePosition(this.neigbourBetButton, this.neighbourBetText, 0.67, 0.82)
				this.neighbourBetText.setOrigin(0.5, 0)
				this.neighbourBetText.setPosition(this.neigbourBetButton.x + (this.neigbourBetButton.displayWidth * 1.025) / 2, this.neigbourBetButton.displayHeight - this.neigbourBetButton.displayHeight * 0.43)

				for (let g = 0; g < 8; g++) {
					this.presetButtons[g].setPosition(this.presetButtons[g].x, this.presetButtons[g].y - this.presetButtons[g].displayHeight)
					this.presetButtons[g].AlignText()
				}
			}

			// RED SNAKE BUTTON PROPER CENTER
			this.presetButtons[4].AlignText(0.53)

			this.interactiveBackground.setDisplaySize(viewportWidth, viewportHeight)

			this.presetsBackground.setPosition(0, 0);
			this.presetsBackground.displayWidth = this.presetButtons[8].x + this.presetButtons[7].x + this.presetButtons[7].displayWidth
			// this.presetsBackground.displayHeight = this.presetButtons[7].y + this.presetButtons[7].displayHeight
			// this.presetsBackground.displayHeight = this.neigbourBetButton.y + this.neigbourBetButton.displayHeight + marginBottom
			this.presetsBackground.displayHeight = this.presetButtons[7].y + this.presetButtons[7].displayHeight + marginBottom

			let firstWidth = this.presetButtons[8].x + this.presetButtons[7].x + this.presetButtons[7].displayWidth
			let greenWidth = firstWidth * 0.997
			let mainHeight = this.neigbourBetButton.y + this.neigbourBetButton.displayHeight + marginBottom
			mainHeight = this.presetButtons[7].y + this.presetButtons[7].displayHeight + marginBottom
			let nextHeight = mainHeight * 0.997
			this.presetsGreenBackground.setPosition((firstWidth - greenWidth) / 2, (mainHeight - nextHeight) / 2);
			this.presetsGreenBackground.displayWidth = greenWidth
			// this.presetsGreenBackground.displayHeight = this.presetButtons[7].y + this.presetButtons[7].displayHeight
			this.presetsGreenBackground.displayHeight = nextHeight
		}

		this.x = viewportWidth / 2 - this.presetsBackground.displayWidth / 2

		if (portraitMode)
			this.y = boardY / 2 - this.presetsBackground.displayHeight / 2
		else
			this.y = viewportHeight - boardHeight / 2 - this.presetsBackground.displayHeight / 2

		this.savedXPos = this.x
		this.savedYPos = this.y
	}

	OnBoardTypeToggle(_isBoard: boolean): void {
		if (_isBoard) {
			//set board misc buttons
			(this.presetButtons[8] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Zero_Game.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtons[9] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Big_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtons[10] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Orphans.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtons[11] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Small_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtons[8] as MiscButton).IsRadio = false;
			(this.presetButtons[9] as MiscButton).IsRadio = false;
			(this.presetButtons[10] as MiscButton).IsRadio = false;
			(this.presetButtons[11] as MiscButton).IsRadio = false;
			this.presetButtons[8].TextElement.text = Language.Get(Messages.ZERO_GAME);
			this.presetButtons[8].TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			this.presetButtons[9].TextElement.text = Language.Get(Messages.BIG_SERIES);
			this.presetButtons[9].TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			this.presetButtons[10].TextElement.text = Language.Get(Messages.ORPHANS);
			this.presetButtons[10].TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			this.presetButtons[11].TextElement.text = Language.Get(Messages.SERIE_58);
			this.presetButtons[11].TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			this.bringToTop(this.presetButtonIcons[0])
			this.bringToTop(this.presetButtonIcons[1])
			this.bringToTop(this.presetButtonIcons[2])
			this.bringToTop(this.presetButtonIcons[3])
		} else {
			//set track wide bets
			(this.presetButtons[8] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtons[9] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtons[10] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtons[11] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtons[8] as MiscButton).IsRadio = true;
			(this.presetButtons[9] as MiscButton).IsRadio = true;
			(this.presetButtons[10] as MiscButton).IsRadio = true;
			(this.presetButtons[11] as MiscButton).IsRadio = true;
			this.bringToTop(this.presetButtons[8])
			this.bringToTop(this.presetButtons[9])
			this.bringToTop(this.presetButtons[10])
			this.bringToTop(this.presetButtons[11])
			this.presetButtons[8].TextElement.text = "+0";
			this.presetButtons[8].TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			this.presetButtons[9].TextElement.text = "+1";
			this.presetButtons[9].TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			this.presetButtons[10].TextElement.text = "+2";
			this.presetButtons[10].TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			this.presetButtons[11].TextElement.text = "+4";
			this.presetButtons[11].TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			this.bringToTop(this.presetButtons[8].TextElement)
			this.bringToTop(this.presetButtons[9].TextElement)
			this.bringToTop(this.presetButtons[10].TextElement)
			this.bringToTop(this.presetButtons[11].TextElement)
			this.resetToStartingRadioButton();
		}

		this.presetButtons[8].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
		this.presetButtons[9].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
		this.presetButtons[10].AlignText(0.5, Client.logic.IsBoard ? 0.45 : 0.5)
		this.presetButtons[11].AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5)
	}

	public resetToStartingRadioButton(): void {
		(this.presetButtons[8] as MiscButton).SetHover();
		this.eventEmitter.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, 0);
		this.eventEmitter.emit(Constants.EVENTS.SET_WIDE_BET, 0);
	}

	TogglePresetsVisibility(): void {
		/**
		 * TODO: FADE TO SAVED SCALE
		 */
		let tweenDuration = 300
		let previousVisibility = this.visible
		if (this.firstRun) {
			this.firstRun = false
			this.setVisible(true)
			this.scale = 0
			this.alpha = 0
			this.x = this.scene.scale.width
			this.y = this.scene.scale.height
			this.scene.tweens.add({
				targets: this,
				duration: tweenDuration,
				x: this.savedXPos,
				y: this.savedYPos,
				scale: 1,
				alpha: 1,
				onComplete: () => {
					this.setVisible(true)
				}
			})
			return
		}
		if (previousVisibility == true) {
			this.scene.tweens.add({
				targets: this,
				duration: tweenDuration,
				x: this.scene.scale.width,
				y: this.scene.scale.height,
				scale: 0,
				alpha: 0,
				onComplete: () => {
					this.setVisible(!this.visible)
				}
			})
		} else {
			this.setVisible(!this.visible)
			this.scene.tweens.add({
				targets: this,
				duration: tweenDuration,
				x: this.savedXPos,
				y: this.savedYPos,
				scale: 1,
				alpha: 1,
				onComplete: () => {

				}
			})
		}
	}

	ResetToggleButton() {
		// this.presetToggleButton.ResetToggle();
	}

	private alignPresetButtons(scaleW: number, scaleH: number, startingX: number, startingY: number): void {

	}

	private alignToggleButtons(): void {

	}

	static LEFT = 0
	static RIGHT = 1
	static CENTER = 0.5
	static MIDDLE = 0.5
	static TOP = 0
	static BOTTOM = 1
	//presets now an element of misc buttons due to graphics changes.
	private presetButtons = new Array<MiscButton>()
	private presetButtonIcons = new Array<Phaser.GameObjects.Image>()
	private presetsBackground: Phaser.GameObjects.Sprite;
	private presetsGreenBackground: Phaser.GameObjects.Sprite;
	private interactiveBackground: Phaser.GameObjects.Rectangle
	/*
	private presetToggleButton: ToggleButton
	private presetToggleButtonText: GameObjects.Text
	*/
	private neigbourBetButton: Phaser.GameObjects.Image
	private neighbourBetText: Phaser.GameObjects.Text

	private firstRun = true
	private savedXPos: number
	private savedYPos: number
}